export default "__VITE_ASSET__gzWNNfrZ__"